import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const indent = css`
    margin-left: ${Spacing.SM}px;

    &:before {
        content: "\u2022";
        margin-left: -${Spacing.SM}px;
    }
`;
